import React from "react";
import { useTranslation } from "react-i18next";
import servicesData from "../data/servicesData";
import { Link } from "react-router-dom";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function Services() {
    const { t } = useTranslation();
    UseScrollAnimation();

    const showData = servicesData.map((el, index) => (
        <div key={index} className="btmAni20002 w-100 flex flex-col gap-[15px] w-[31%]">
            <div>
                <img src={el.icons} alt="" />
            </div>
            <div>
                <div className="text-white font-bold text-[20px]">{t(`${el.title}`)}</div>
                <p className="text-[#989898] text-[15px]">{t(`${el.details}`)}</p>
            </div>
        </div>
    ))

    return (
        <>
            <section className="landingPages">
                <div className="container h-[70vh] flex flex-col justify-center gap-[10px]">
                    <div className="btmAni2000 text-[40px] font-bold text-white  capitalize">{t("Services")}</div>
                    <div className="btmAni25002 flex items-center gap-[5px] text-white">
                        <Link className="text-white" to={"/"}>{t("Home")}</Link>
                        -
                        <div className="text-[#016E82]">{t("Services")}</div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[20px]">
                    <div className="flex flex-col py-[20px] w-fit">
                        <div className="btmAni20002 flex items-center gap-[5px] capitalize">
                            <span className="h-[2px] w-[25px] bg-[#A0642E]"></span>
                            <div className="font-bold text-white">{t("WHY CHOOSE ME")}</div>
                        </div>
                        <div className="btmAni3000 font-bold text-white text-[35px]">{t("The Best Service For Our Customers")}</div>
                    </div>
                    <div className="f-col flex flex-wrap gap-[20px] justify-between items-center">
                        {showData}
                    </div>
                </div>
            </section>

            <section className="relative py-[40px] bg-[#1E1E1E]">
                <div className="container flex items-center justify-between">
                    <div className="js-scroll fade-btm d-none w-[48%]">
                        <img className="w-full h-full" src={require("../../assets/image/services-cam.svg").default} alt="" />
                    </div>
                    <div className="js-scroll fade-top w-100 w-[48%] flex flex-col items-center justify-center gap-5">
                        <div className="flex flex-col gap-[6px] text-center">
                            <div className="font-bold text-[25px] text-white">
                                {t("Capturing The Moments Captive Your Heart")}
                            </div>
                            <p className="text-[16px] text-white">{t("Capture Your Special Moments with a Professional Touch")}</p>
                        </div>
                        <Link className="js-scroll fade-btm bg-[#016E82] text-white px-[20px] py-[8px] rounded font-bold capitalize" to={"/booking"}>{t("Book Now")}</Link>
                    </div>
                </div>
            </section>
        </>
    );
}